import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { CompanyData } from '@/features/privateCompanies/types/companies.type'
import { BriefcaseBusinessIcon } from 'lucide-react'

type ClientDetailsProps = {
  client?: CompanyData
}

export const ClientDetails = ({ client }: ClientDetailsProps) => {
  return (
    <div className="">
      <div className="flex gap-2 items-center">
        <ImageWithPlaceholder
          className="size-8"
          iconClassName="size-6"
          url={client?.general_information?.company_logo?.url}
          placeholderIcon={BriefcaseBusinessIcon}
        />
        <p className="font-bold text-sm">{client?.general_information?.fantasy_name}</p>
      </div>
    </div>
  )
}
